import settings from './_mediaZoom.settings';
import * as utils from './_mediaZoom.utils';
import SwiperSlider from './../../../legacy/_swiperSlider.class';
export default class MediaZoom {
  constructor(mediaZoom) {
    this.mediaZoom = mediaZoom;
    this.openButtons = document.querySelectorAll('.js-open-media-zoom');
    this.closeButton = mediaZoom.querySelector('.js-close-media-zoom');
    this.thumbnails = mediaZoom.querySelector('.mz__thumbnails');
    this.thumbnailsItems = this.thumbnails.querySelectorAll('.mz__thumbnails__list-item');
    this.thumbnailsArrowButtons = this.thumbnails.querySelectorAll('.mz__thumbnails__button');
    this.medias = mediaZoom.querySelector('.mz__medias__list');
    this.mediasSwiper = mediaZoom.querySelector('.mz__medias__swiper');
    this.mediasItems = this.medias.querySelectorAll('.mz__medias__list-item');
    this.mediasArrowButtons = this.mediasSwiper.querySelectorAll('.ka-nav-button');
    this.mediasZoomButtons = mediaZoom.querySelectorAll('.mz__medias__buttons button');
    this.currentIndex = 0;
    this.currentThumbnail = this.thumbnailsItems[0];
    this.currentMedia = this.mediasItems[0];
    this.currentZoom = settings.zoom.min;
    this.currentPinch = 1;
    this.currentPosX = 0;
    this.currentPosY = 0;
    this.isMoving = false;
    lm.DOMReady(() => this.init());
  }

  /**
   * Init module and set event listeners
   */
  init() {
    // Open/Close
    this.openButtons.forEach(button => button.addEventListener('click', e => this.open(e)));
    this.closeButton.addEventListener('click', e => this.close(e));

    // Thumbnails
    this.thumbnailsArrowButtons.forEach(arrow => arrow.addEventListener('click', e => this.onThumbnailsArrowClick(e, arrow)));
    this.thumbnailsItems.forEach(item => item.addEventListener('click', e => this.onThumbnailsItemsClick(e)));
    this.thumbnails.addEventListener('scroll', () => utils.debounce(this.toggleThumbnailsArrowButtons, 3000));

    // Medias
    this.mediasArrowButtons.forEach(arrow => arrow.addEventListener('click', e => this.onMediasArrowClick(e, arrow)));
    this.mediasZoomButtons.forEach(button => button.addEventListener('click', () => this.onZoomButtonsClick(button.dataset.direction)));
    this.medias.addEventListener('scroll', () => utils.debounce(this.toggleMediasArrowButtons, 3000));

    // Launch swiper
    this.mediasSwiper && new SwiperSlider(this.mediasSwiper);

    // Init keyboard actions
    this.initKeyboardActions();
  }

  /**
   * User click on a thumbnail item
   * @param {event} event
   */
  onThumbnailsItemsClick(event) {
    this.enableArrows(false);
    this.goTo(event.target.closest('.mz__thumbnails__list-item').dataset.index || 0, 'smooth');
  }
  /**
   * Manage keyboard interactions for A11Y
   */
  initKeyboardActions() {
    window.addEventListener('keydown', event => {
      if (this.isOpen && !this.isMoving) {
        const {
          min,
          max,
          step
        } = settings.zoom;
        if (event.key === 'Escape') {
          this.close();
        }
        switch (event.key) {
          case 'ArrowLeft':
            /* Go to previous slide or Drag to left if image is zoomed */
            if (!this.isZoomed) this.goTo(this.currentIndex - 1, 'smooth');else this.drag(this.currentMedia, this.currentPosX += 100, this.currentPosY);
            break;
          case 'ArrowRight':
            /* Go to next slide or Drag to right if image is zoomed */
            if (!this.isZoomed) this.goTo(this.currentIndex + 1, 'smooth');else this.drag(this.currentMedia, this.currentPosX -= 100, this.currentPosY);
            break;
          case 'ArrowUp':
            /* Drag to top if image is zoomed */
            this.drag(this.currentMedia, this.currentPosX, this.currentPosY += 100);
            break;
          case 'ArrowDown':
            /* Drag to bottom if image is zoomed */
            this.drag(this.currentMedia, this.currentPosX, this.currentPosY -= 100);
            break;
          case '+':
            /* Zoom In   */
            this.zoom(this.currentMedia, utils.getMinMax(this.currentZoom + step, min, max), true);
            break;
          case '-':
            /* Zoom Out */
            this.zoom(this.currentMedia, utils.getMinMax(this.currentZoom - step, min, max), true);
            break;
        }
      }
    });
  }

  /**
   * Init user interaction events
   */
  initHammer() {
    import(/*webpackChunkName: "hammerjs" */'hammerjs').then(module => {
      this.Hammer = new module.default(this.medias, {
        inputClass: Hammer.TouchMouseInput
      });
      this.Hammer.on('pan', e => this.onPan(e)).get('pan').set(settings.hammer.pan);
      this.Hammer.on('pinch', e => this.onPinch(e)).get('pinch').set(settings.hammer.pinch);
      this.Hammer.on('swipe', e => this.onSwipe(e)).get('swipe').set(settings.hammer.swipe);
      this.Hammer.on('tap', e => this.onTap(e)).get('tap').set(settings.hammer.tap);
      !utils.isTouchDevice() && this.medias.addEventListener('mousewheel', e => this.onMouseWheel(e), {
        passive: false
      });
    }).catch(console.error);
  }

  /**
   * Open media zoom in full page
   * @param {event} event
   */
  open(event) {
    const index = event.target.closest('.js-open-media-zoom').dataset.index || 0;
    this.goTo(index, 'instant');
    if (!this.Hammer) this.initHammer();
    window.addEventListener('resize', () => this.close(), {
      once: true
    });
    document.documentElement.classList.add('is-scroll-locked');
    this.mediaZoom.classList.add('active');
    this.isOpen = true;
    this.closeButton.focus();
    this.toggleThumbnailsArrowButtons();
    this.toggleMediasArrowButtons();
    lm.lazyload.observe();
  }

  /**
   * Close Media zoom
   */
  close() {
    document.documentElement.classList.remove('is-scroll-locked');
    this.mediaZoom.classList.remove('active');
    this.goTo(0, 'instant');
    this.isOpen = false;
    this.pauseAllVideos();
    this.resetZoom();
    this.resetDrag();
  }

  /**
   * User drag image
   * @param {event} event
   */
  onPan(event) {
    if (this.isZoomed && !this.isMoving) {
      const image = this.currentMedia.querySelector('img');
      if (!this.isDragging) {
        this.isDragging = true;
        this.currentMedia.classList.add('grabbing');
      }
      this.drag(this.currentMedia, event.deltaX + this.currentPosX, event.deltaY + this.currentPosY);
      if (event.isFinal) {
        this.currentPosX = image.offsetLeft;
        this.currentPosY = image.offsetTop;
        this.isDragging = false;
        this.currentMedia.classList.remove('grabbing');
      }
    }
  }

  /**
   * User tap on screen or click
   * @param {event} event
   */
  onTap(event) {
    if (!this.isMoving) {
      const {
        max,
        min
      } = settings.zoom;
      let newZoomValue;
      if (this.currentZoom < max / 2) newZoomValue = max / 2;
      if (this.currentZoom >= max / 2) newZoomValue = max;
      if (this.currentZoom === max) newZoomValue = min;
      this.zoom(this.currentMedia, newZoomValue, true);
    }
  }

  /**
   * User pinch image
   * @param {event} event
   */
  onPinch(event) {
    if (!this.isMoving) {
      const {
        min,
        max
      } = settings.zoom;
      const pinchValue = this.currentPinch * event.scale;
      const newZoomValue = Math.round(utils.getMinMax(pinchValue * 100, min, max));
      this.zoom(this.currentMedia, newZoomValue, false);
      this.Hammer.off('pinchend').on('pinchend', () => {
        this.currentPinch = pinchValue;
      });
    }
  }

  /**
   * User swipe image
   * @param {event} event
   */
  onSwipe(event) {
    if (!this.isMoving) {
      if (event.deltaX > 0) this.goTo(this.currentIndex - 1, 'smooth');
      if (event.deltaX < 0) this.goTo(this.currentIndex + 1, 'smooth');
    }
  }

  /**
   * User uses his mouse wheel
   * @param {event} event
   */
  onMouseWheel(event) {
    event.preventDefault();
    if (!this.isMoving) {
      const {
        min,
        max,
        wheel_speed
      } = settings.zoom;
      const newZoomValue = utils.getMinMax(this.currentZoom - wheel_speed * event.deltaY, min, max);
      this.zoom(this.currentMedia, newZoomValue, false);
    }
  }

  /**
   * When user uses thumbnails arrow (just scroll thumbnails)
   * @param {event} event
   * @param {node} arrow
   */
  onThumbnailsArrowClick(event, arrow) {
    if (this.thumbnailsItems.length > 1) {
      let top, left;
      if (arrow.dataset.controls === 'prev') {
        top = this.thumbnails.scrollTop - this.thumbnailsItems[1].offsetTop;
        left = this.thumbnails.scrollLeft - this.thumbnailsItems[1].offsetLeft;
      }
      if (arrow.dataset.controls === 'next') {
        top = this.thumbnails.scrollTop + this.thumbnailsItems[1].offsetTop;
        left = this.thumbnails.scrollLeft + this.thumbnailsItems[1].offsetLeft;
      }
      this.thumbnails.scrollTo({
        top,
        left,
        behavior: 'smooth'
      });
    }
  }

  /**
   * When user uses medias arrow
   * @param {event} event
   * @param {node} arrow
   */
  onMediasArrowClick(event, arrow) {
    this.enableArrows(false);
    if (arrow.dataset.controls === 'prev') this.goTo(this.currentIndex - 1, 'smooth');
    if (arrow.dataset.controls === 'next') this.goTo(this.currentIndex + 1, 'smooth');
  }

  /**
   * Enable or disable arrows buttons
   * @param {boolean} state
   */
  enableArrows(state = true) {
    [...this.thumbnailsArrowButtons, ...this.mediasArrowButtons].forEach(button => button.disabled = !state);
  }

  /**
   * Go to a specific index
   * (synchronize thumbnails and medias)
   * @param {number} index
   * @param {string} behavior scroll behavior (smooth, instant or null)
   */
  goTo(index = 0, behavior = null) {
    index = utils.getMinMax(+index, 0, this.thumbnailsItems.length);
    if (index === this.currentIndex) behavior = 'instant';
    if (this.thumbnailsItems[index] && this.mediasItems[index]) {
      this.isMoving = true;
      this.currentIndex = index;
      this.currentThumbnail = this.thumbnailsItems[index];
      this.currentMedia = this.mediasItems[index];

      // Highlight thumbnail
      this.thumbnailsItems.forEach(item => item.classList.toggle('active', +item.dataset.index === this.currentIndex));

      // Synchronize thumbnails and medias
      setTimeout(() => {
        this.medias.scrollTo({
          top: 0,
          left: Math.round(this.medias.clientWidth * index),
          behavior
        });
        this.thumbnails.scrollTo({
          top: Math.round(this.currentThumbnail.offsetTop - this.thumbnailsArrowButtons[0].clientHeight),
          left: Math.round(this.currentThumbnail.offsetLeft),
          behavior
        });
      }, 0);

      // Hide Zoom buttons if media is not a photo
      this.mediasZoomButtons.forEach(button => {
        button.classList.toggle('hidden', !this.currentMedia.classList.toString().includes('photo'));
      });

      // Reset All medias after transition
      const duration = behavior === 'smooth' ? 750 : 0;
      clearTimeout(this.resetTimeout);
      this.resetTimeout = setTimeout(() => {
        this.pauseAllVideos();
        this.resetZoom();
        this.resetDrag();
        this.toggleThumbnailsArrowButtons();
        this.toggleMediasArrowButtons();
        this.enableArrows(true);
        this.isMoving = false;
      }, duration);
    }
  }

  /**
   * add a gradient over thumbnails if edge are not reached
   * Display thumbnails arrows on thumbnails if necessary
   */
  toggleThumbnailsArrowButtons() {
    const thumbnailScrollTop = this.thumbnails.scrollTop;
    const thumbnailsHeight = this.thumbnails.scrollHeight - this.thumbnails.clientHeight;
    const [arrowPrev, arrowNext] = this.thumbnailsArrowButtons;
    arrowPrev.classList.toggle('hidden', this.thumbnails.scrollHeight < this.mediaZoom.clientHeight);
    arrowPrev.classList.toggle('active', thumbnailScrollTop > 0);
    arrowNext.classList.toggle('hidden', this.thumbnails.scrollHeight < this.mediaZoom.clientHeight);
    arrowNext.classList.toggle('active', thumbnailScrollTop < thumbnailsHeight);
  }

  /**
   * Display medias arrows on thumbnails if necessary
   */
  toggleMediasArrowButtons() {
    const mediasScrollLeft = this.medias.scrollLeft;
    const mediasWidth = (this.mediasItems.length - 1) * this.medias.clientWidth;
    const offset = Math.floor(this.medias.clientWidth / 10);
    const [arrowPrev, arrowNext] = this.mediasArrowButtons;
    arrowPrev.classList.toggle('ka-nav-button--hidden', mediasScrollLeft <= offset);
    arrowNext.classList.toggle('ka-nav-button--hidden', mediasScrollLeft >= mediasWidth - offset);
  }

  /**
   * Rewind and pause all videos
   */
  pauseAllVideos() {
    this.mediaZoom.querySelectorAll('video').forEach(video => {
      video.pause();
      video.currentTime = 0;
    });
  }

  /**
   * onZoomButtonsClick on current media
   * @param {string} direction (in or out)
   */
  onZoomButtonsClick(direction) {
    const {
      min,
      max,
      step
    } = settings.zoom;
    const newZoomValue = utils.getMinMax(this.currentZoom + {
      in: 1,
      out: -1
    }[direction] * step, min, max);
    this.zoom(this.currentMedia, newZoomValue, true);
    this.currentZoom = newZoomValue;
  }

  /**
   * Disable zoom button if zoom reach edges
   * @param {number} value
   */
  toggleZoomButtons(value) {
    const {
      min,
      max
    } = settings.zoom;
    const [minusButton, plusButton] = this.mediasZoomButtons;
    minusButton.classList.toggle('disabled', value <= min);
    plusButton.classList.toggle('disabled', value >= max);
  }

  /**
   * Apply a zoom value on a specific item
   * @param {node} media item to zoom
   * @param {number} value percentage of zoom
   * @param {boolean} animation CSS transition, default true
   */
  zoom(media, value, animation = true) {
    const {
      min
    } = settings.zoom;
    const image = media.querySelector('img');
    this.isZoomed = value > min;
    if (image) {
      image.classList.toggle('transition', animation);
      this.toggleZoomButtons(value);
      this.currentZoom = value;
      if (value > min) {
        media.classList.add('zoomed');
        image.style.transform = `scale(${value / 100})`;
        image.dataset.zoom = value;
      } else {
        media.classList.remove('zoomed');
        image.removeAttribute('data-zoom');
        image.style.transform = null;
        this.resetDrag();
      }
      image.addEventListener('transitionend', () => {
        image.classList.remove('transition');
      }, {
        once: true
      });
    }
  }

  /**
   * Reset zoom value on every medias image
   */
  resetZoom() {
    this.mediasItems.forEach(item => this.zoom(item, settings.zoom.min, false));
    this.currentZoom = settings.zoom.min;
    this.currentPinch = 1;
  }

  /**
   * Apply a zoom value on a specific item
   * @param {node} media item to zoom
   * @param {number} value percentage of zoom
   */
  drag(media, x, y) {
    const image = media.querySelector('img');
    if (image) {
      image.style.left = x ? `${x}px` : null;
      image.style.top = x ? `${y}px` : null;
      x ? image.dataset.x = x : image.removeAttribute('data-x');
      y ? image.dataset.y = y : image.removeAttribute('data-y');
      media.classList.toggle('dragged', x || y);
    }
  }

  /**
   * Reset drag position on every medias image
   */
  resetDrag() {
    this.mediasItems.forEach(item => this.drag(item, 0, 0));
    this.currentPosX = 0;
    this.currentPosY = 0;
  }
}